import React from "react";
import { Row, Spin, Dropdown } from "antd";
import {
  BellFilled,
  BellOutlined,
  BellTwoTone,
  DownOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import BannerTop from "../../components/BannerTop/BannerTop";
import Localize from "../../components/Localized/Localize.comp";
import { translateRegistryOnView } from "../../libs/utils";
import TagManage from "../../components/Tag/TagManage";
import { associationsTagIdCompanyAction } from "../../actions/tag.actions";
import { Social } from "../../components/Cards/Social";
import { TO_EMAIL_ALERTS_TYPES_MAP } from "../../libs/emailAlerts";

/**
 * CompanyHeader component
 * Displays company logo, name, category, parent group, tags (favourites), and email alerts follow button.
 */
const CompanyHeader = ({
  data,
  permissions,
  match,
  selectedAlerts,
  setSelectedAlerts,
  showRightSide = true,
}) => {
  const dispatch = useDispatch();
  const associatedTagsIdsCompany = useSelector(
    (state) => state.tag.tagsForIdsCompany,
  );

  return (
    <div className="companyPage__head profile__container">
      <BannerTop>
        <Row className="profile__container--left" align="middle">
          {data.logo && (
            <div className="profile__avatar">
              <img
                src={data.logo}
                className="companyPage__head-logo"
                alt={`logo-${data.name}`}
              />
            </div>
          )}
          <div className="profile__data">
            <div className="grey-light-color">
              {translateRegistryOnView(
                data.main_category,
                "main_category",
                true,
              )
                ? translateRegistryOnView(
                    data.main_category,
                    "main_category",
                    true,
                  )
                : data.main_category}
            </div>
            <h2 className="grey-light-color">{data.name}</h2>
            {data.parent_firm_name && (
              <div className="grey-light-color">
                {Localize("COMMON.GROUP", [data.parent_firm_name])}
              </div>
            )}
            <div>
              {associatedTagsIdsCompany?.loading ? (
                <Spin size="small" />
              ) : (
                <TagManage
                  tagInfo={associatedTagsIdsCompany}
                  entityId={match.params.id}
                  onAssociateTag={() => {
                    dispatch(
                      associationsTagIdCompanyAction({
                        data: { id: [match.params.id] },
                      }),
                    );
                  }}
                />
              )}
            </div>
          </div>
        </Row>
        {showRightSide && (
          <Row className="profile__container--right" align="middle">
            {permissions.emailAlerts ? (
              <div>
                <Dropdown.Button
                  icon={
                    <DownOutlined style={{ color: "rgba(0, 0, 0, 0.65)" }} />
                  }
                  loading={false}
                  menu={{
                    items: Object.values(TO_EMAIL_ALERTS_TYPES_MAP).map(
                      (la, i) => ({
                        label: Localize(
                          `PAGES.SEARCH.COMPANY.ALERTS.EVENTS.${la}`,
                        ),
                        key: i,
                      }),
                    ),
                    selectable: true,
                    selectedKeys: selectedAlerts,
                    onSelect: (obj) => {
                      setSelectedAlerts([...selectedAlerts, obj.key]);
                    },
                    onDeselect: (obj) => {
                      setSelectedAlerts(
                        selectedAlerts.filter((s) => s !== obj.key),
                      );
                    },
                  }}
                  onClick={() => {
                    if (selectedAlerts.length < 6) {
                      setSelectedAlerts(["0", "1", "2", "3", "4", "5"]);
                    } else {
                      setSelectedAlerts([]);
                    }
                  }}
                >
                  {{
                    0: (
                      <BellOutlined
                        style={{
                          color: "rgba(0, 0, 0, 0.65)",
                          fontSize: 14,
                        }}
                      />
                    ),
                    6: (
                      <BellFilled
                        style={{
                          color: "rgba(0, 0, 0, 0.65)",
                          fontSize: 14,
                        }}
                      />
                    ),
                  }[selectedAlerts.length] || (
                    <BellTwoTone
                      style={{ color: "rgba(0, 0, 0, 0.65)", fontSize: 14 }}
                      twoToneColor="#777777"
                    />
                  )}{" "}
                  {Localize("PAGES.SEARCH.COMPANY.ALERTS.FOLLOW")}
                </Dropdown.Button>
              </div>
            ) : null}

            <Social external={data.external_links} />
          </Row>
        )}
      </BannerTop>
    </div>
  );
};

export default CompanyHeader;
